// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-number-box[data-v-48a501ea] {\n  background-color: #2db782;\n  width: 30px;\n}", ""]);
// Exports
module.exports = exports;
